var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2444_10367",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2444_10367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 21V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H17C17.55 4 18.0208 4.19583 18.4125 4.5875C18.8042 4.97917 19 5.45 19 6V11.075C18.8333 11.0417 18.6667 11.0208 18.5 11.0125C18.3333 11.0042 18.1667 11 18 11C17.8333 11 17.6667 11.0042 17.5 11.0125C17.3333 11.0208 17.1667 11.0417 17 11.075V6H5V16H12.075C12.0417 16.1667 12.0208 16.3333 12.0125 16.5C12.0042 16.6667 12 16.8333 12 17C12 17.1667 12.0042 17.3333 12.0125 17.5C12.0208 17.6667 12.0417 17.8333 12.075 18H6L3 21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 19.6L18 21L14 17L18 13L19.4 14.4L17.825 16H22V18H17.825L19.4 19.6Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.6646113c55fa8b57f77dcf11f19759ef.svg";
export { ForwardRef as ReactComponent };